module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('walkthrough-stepper', {
    attrs: {
      "pageTitles": _vm.page_titles,
      "stepperTitle": "Submissions and Assessment"
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var page = ref.page;

        return [_c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (page === 0),
            expression: "page === 0"
          }],
          staticClass: "mh3 pa3 flex-grow"
        }, [_c('div', {
          staticClass: "flex justify-center mb2"
        }, [_c('i', {
          staticClass: "far fa-comment-alt fa-3x ma3"
        })]), _vm._v(" "), _c('p', {
          staticClass: "pl-subheading tl"
        }, [_vm._v("\n        Each student submits a unique response to the prompt before joining\n        the discussion. Responses can include text, images, videos and\n        hyperlinks.\n      ")])]), _vm._v(" "), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (page === 1),
            expression: "page === 1"
          }],
          staticClass: "mh3 pa3 flex-grow"
        }, [_c('div', {
          staticClass: "flex justify-center mb2"
        }, [_c('i', {
          staticClass: "fas fa-clipboard-list fa-3x ma3"
        })]), _vm._v(" "), _c('p', {
          staticClass: "pl-subheading tl"
        }, [_vm._v("\n        Click on the "), _c('span', {
          staticClass: "italics"
        }, [_vm._v("Assessment Tab")]), _vm._v(" in the\n        submission card to read student posts, provide feedback and see a\n        summary of all the comments they made during the RoundTable.\n      ")])])]
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-cfab8a84!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineWalkthrough/pages/onlineWalkthroughSubmissionCard.vue
// module id = 1341
// module chunks = 61